import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import IndexPage from './FeedbackLanguageIndexPage';
import DetailPage from './FeedbackLanguageDetailPage';
import ProgressBar from '../../../../components/progress-bar';

import {
  fetchAllFilters,
} from '../../FilterActions';

class FeedbackLanguagePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ loading: true, loaded: false }, () => {
      this.props.dispatch(fetchAllFilters())
        .then(
          () => {
            this.setState({ loaded: true, loading: false });
          },
          () => {
          },
        );
    });
  }

  render() {
    const { location: { pathname } } = this.props;
    const { loading, loaded } = this.state;

    return (
      <div className="container">
        <Helmet title="Language Settings | Organization Setup" />
        {loading && <ProgressBar />}
        {!loading && loaded &&
          <div>
            <ul className="nav nav-tabs">
              <LinkContainer to="/setup/feedback-languages/opportunities">
                <NavItem>Opportunity Based</NavItem>
              </LinkContainer>
              <LinkContainer to="/setup/feedback-languages/accounts">
                <NavItem>Account Based</NavItem>
              </LinkContainer>
            </ul>
            <p>&nbsp;</p>
            <Switch>
              <Route
                path="/setup/feedback-languages/:source(opportunities|accounts)"
                key={pathname}
                exact
                render={(props) => {
                  return (<IndexPage {...props} />);
                }}
              />
              <Route
                path="/setup/feedback-languages/:source(opportunities|accounts)/:id"
                render={(props) => {
                  return (<DetailPage {...props} />);
                }}
              />
              {(pathname === '/setup/feedback-languages' && <Redirect to="/setup/feedback-languages/opportunities" />)}
            </Switch>
          </div>
        }
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(/* state */) {
  return {
  };
}

FeedbackLanguagePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};
FeedbackLanguagePage.defaultProps = {
};
FeedbackLanguagePage.contextTypes = {
};


export default withRouter(connect(mapStateToProps)(FeedbackLanguagePage));
